import { render, staticRenderFns } from "./AutomatedRulesFolder.vue?vue&type=template&id=7f71ccd9&scoped=true&"
import script from "./AutomatedRulesFolder.vue?vue&type=script&lang=ts&"
export * from "./AutomatedRulesFolder.vue?vue&type=script&lang=ts&"
import style0 from "./AutomatedRulesFolder.vue?vue&type=style&index=0&id=7f71ccd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71ccd9",
  null
  
)

export default component.exports